<script setup>
/**
 * Canvas placeholder for block types the public site has no render component for
 * yet (currently `media_list`). Keeps the block visible and selectable in the
 * builder so editors can still configure it via the settings panel.
 */
defineProps({ type: { type: String, required: true } });
</script>

<template>
  <section class="section">
    <div class="container-x">
      <div class="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-6 py-10 text-center text-slate-500">
        <p class="text-sm font-medium">此區塊類型（{{ type }}）尚無前台預覽</p>
        <p class="mt-1 text-xs">可在右側設定面板編輯其內容。</p>
      </div>
    </div>
  </section>
</template>
